export function formatRenewalDate(value) {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}

function isPaidActive(license) {
  if (!license) return false;
  const accessOn = license.active === true || license.has_access === true;
  const paidLicense = license.license_status === "active";
  const paidMeta = Boolean(
    license.paid_plan || license.billing_provider === "paddle" || license.paddle_subscription_id
  );
  return accessOn && paidLicense && paidMeta;
}

export function isManualAccess(license) {
  return license?.access_source === "manual" || (
    license?.manual_access_active === true &&
    license?.access_source !== "paddle_paid" &&
    license?.access_source !== "paddle_trial" &&
    license?.access_source !== "admin"
  );
}

export function customerSubscriptionBadge(license) {
  const accessOn = license?.active === true || license?.has_access === true;
  if (isPaidActive(license)) {
    const plan = license.paid_plan || "Basic";
    const renews = formatRenewalDate(
      license.billing_period_end || license.subscription_current_period_end
    );
    return {
      on: true,
      title: `${plan} Plan • Active`,
      subtitle: renews ? `Renews ${renews}` : null,
    };
  }
  if (license?.trial_status === "active" && license?.license_status !== "active" && license?.access_source !== "manual") {
    const days = Number(license.trial_days_remaining) || 0;
    return {
      on: true,
      title: "Free Trial",
      subtitle: `${days} day${days === 1 ? "" : "s"} left`,
    };
  }
  if (isManualAccess(license) && accessOn) {
    const until = formatRenewalDate(license.manual_access_expires_at);
    return {
      on: true,
      title: "Manual Access",
      subtitle: until ? `Expires ${until}` : null,
    };
  }
  if (!accessOn) {
    if (license?.is_blocked) {
      return { on: false, title: "Blocked", subtitle: null };
    }
    return { on: false, title: "Inactive / Subscription required", subtitle: null };
  }
  return { on: true, title: "Active", subtitle: null };
}
